import type { ImagePresetKey } from '@api/types.gen'

export type ImageLayout = 'fixed' | 'fluid'

export interface ImagePreset {
  layout: ImageLayout
  width?: number
  sizes?: string
  quality?: number
}

export const IMAGE_PRESETS: Record<Exclude<ImagePresetKey, 'custom'>, ImagePreset> = {
  original: {
    // Pass-through: no width, no quality, no format modifiers applied downstream.
    // Serves the uploaded file as-is at native resolution.
    layout: 'fixed',
  },

  tiny: {
    layout: 'fixed',
    width: 100,
    quality: 70,
  },

  small: {
    layout: 'fixed',
    width: 250,
    quality: 90,
  },

  medium: {
    layout: 'fluid',
    sizes: 'default:100vw sm:50vw md:33vw lg:400px',
    quality: 75,
  },

  large: {
    layout: 'fluid',
    sizes: 'default:100vw md:50vw lg:800px',
    quality: 80,
  },

  full: {
    layout: 'fluid',
    sizes: 'default:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw',
    quality: 80,
  },

  background: {
    // TECHNICAL: Fluid layout. We define the same full-width viewports as "full",
    // but we aggressively drop the quality to 40. Nuxt Image will aggressively compress
    // the WebP output, crushing the file size down to almost nothing.
    layout: 'fluid',
    sizes: 'default:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw',
    quality: 40,
  },
} as const
